"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findTokenByMint = exports.getMintAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
const tokens_1 = require("./data/tokens");
function getMintAddress(token) {
    const match = Object.entries(tokens_1.TOKENS).find(([tkn, _tokenInfo]) => tkn === token);
    if (!match) {
        throw new Error("Token" + token + "not found:");
    }
    const [_tkn, tokenInfo] = match;
    return new anchor_1.web3.PublicKey(tokenInfo.mintAddress);
}
exports.getMintAddress = getMintAddress;
function findTokenByMint(mint) {
    const match = Object.entries(tokens_1.TOKENS).find(([_tkn, tokenInfo]) => tokenInfo.mintAddress === mint.toString());
    if (!match) {
        throw new Error("Error finding token by mint " + mint.toString());
    }
    const [tkn, _tokenInfo] = match;
    return tkn;
}
exports.findTokenByMint = findTokenByMint;
//# sourceMappingURL=tokensParser.js.map